import { useEffect, useState } from "react";
import { useAppSelector } from "Redux/hooks";
import { selectStyle } from "Redux/appSlice";
type Voice = {
  label: string;
  id: string;
};

type Props = {
  voices: Voice[];
  onClick: (value: string) => void;
  value?: string;
};

//  @function ProducerSearchSelector
//  @param {Object} voices - array of objects containing all available voices and their IDs
//  @param {string} voices.label - voice text to show
//  @param {string} voices.label - ID used to identify the selected voice
//  @param {function} onClick - function to be called when the selected voice is changed, ID is passed as argument
//  @param {string}  value - default value
//  @returns {React.Node}
export default function ProducerSearchSelector({
  voices = [{ label: "All", id: "selector_All" }],
  onClick,
  value = "selector_All",
}: Props) {
  const { color2 } = useAppSelector(selectStyle);
  const [showing, changeShowing] = useState(false);
  const [selected, changeSelected] = useState(voices[0].id);
  const colouring = {
    background: color2 ? color2 : "#9FC131",
    colour: {
      text: "#FFFFFF",
      border: "#383838",
    },
  } as const;
  const toggleShowing = () => {
    changeShowing(!showing);
    // changeSelected(selected);
  };
  const toggleSelected = (selection: string) => {
    toggleShowing();
    changeSelected(selection);
    onClick(selection);
  };

  useEffect(() => {
    changeSelected(value);
    onClick(value);
  }, [value]);

  return (
    <div
      className="flex flex-row rounded w-fit"
      style={{
        backgroundColor: colouring.background,
        color: colouring.colour.text,
      }}
    >
      <div
        className="cursor-pointer text-xl w-fit select-none px-1"
        onClick={() => toggleShowing()}
      >
        {showing ? "▵" : "▿"}
      </div>
      <ul className="flex flex-col gap-1 text-xl w-fit select-none px-2 text-center">
        {voices.map((voice) => {
          if (showing) {
            return (
              <li
                className="cursor-pointer"
                id={voice.id}
                key={voice.id}
                onClick={() => toggleSelected(voice.id)}
              >
                {voice.label}
              </li>
            );
          } else if (!showing) {
            if (selected === voice.id) {
              return (
                <li
                  className="cursor-pointer"
                  id={voice.id}
                  key={voice.id}
                  onClick={() => toggleShowing()}
                >
                  {voice.label}
                </li>
              );
            }
          }
        })}
      </ul>
    </div>
  );
}
